import { __assign, __read, __spreadArray } from "tslib";
import React, { useState, useRef, useMemo, useLayoutEffect, } from 'react';
import { Dropdown } from '@mercell/dropdown-react';
import { Input, InputContainer, InputLeftElement, InputRightElement, } from '@mercell/input-react';
import { useWindowSizeHook } from '@mercell/use-window-resize-react-hook';
import cx from 'classnames';
export var InputDropdown = function (_a) {
    var _b;
    var _c = _a.selectedOptions, selectedOptions = _c === void 0 ? null : _c, _d = _a.inputValue, inputValue = _d === void 0 ? '' : _d, _e = _a.pinnedOptions, pinnedOptions = _e === void 0 ? [] : _e, _f = _a.dropdownSide, dropdownSide = _f === void 0 ? 'left' : _f, _g = _a.dropdownOptions, dropdownOptions = _g === void 0 ? [] : _g, _h = _a.dropdownMaxWidth, dropdownMaxWidth = _h === void 0 ? '170px' : _h, _j = _a.inputProps, inputProps = _j === void 0 ? {} : _j, _k = _a.inputContainerProps, inputContainerProps = _k === void 0 ? {} : _k, _l = _a.inputElementProps, inputElementProps = _l === void 0 ? {} : _l, _m = _a.dropdownProps, dropdownProps = _m === void 0 ? {} : _m, onChangeInputDropdown = _a.onChangeInputDropdown, _o = _a.disabled, disabled = _o === void 0 ? false : _o, _p = _a.invalid, invalid = _p === void 0 ? false : _p;
    var _q = __read(useState(), 2), inputWidth = _q[0], setInputWidth = _q[1];
    var width = useWindowSizeHook().width;
    var ref = useRef(null);
    var Element = dropdownSide === 'left' ? InputLeftElement : InputRightElement;
    var options = useMemo(function () {
        if (pinnedOptions && !pinnedOptions.length) {
            return dropdownOptions;
        }
        var newDropdownOptions = __spreadArray([], __read(dropdownOptions), false);
        var filteredPinnedOptions = pinnedOptions.filter(function (pinned) {
            var optionFound = dropdownOptions.find(function (option) {
                return option.value === pinned.value &&
                    option.label === pinned.label;
            });
            if (optionFound) {
                newDropdownOptions.splice(newDropdownOptions.indexOf(optionFound), 1);
                return true;
            }
            return false;
        });
        if (filteredPinnedOptions.length) {
            filteredPinnedOptions[filteredPinnedOptions.length - 1].lastPinned =
                true;
        }
        return __spreadArray(__spreadArray([], __read(filteredPinnedOptions), false), __read(newDropdownOptions), false);
    }, [pinnedOptions, dropdownOptions]);
    useLayoutEffect(function () {
        var _a;
        if (ref.current !== null) {
            setInputWidth((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth);
        }
    }, [width]);
    var input = (React.createElement(Input, __assign({}, inputProps, { value: inputValue, onChange: function (event) {
            return onChangeInputDropdown(event.target.value, selectedOptions);
        }, disabled: disabled, invalid: invalid })));
    return (React.createElement(InputContainer, __assign({}, inputContainerProps, { ref: ref }),
        dropdownSide === 'left' && input,
        React.createElement(Element, __assign({}, inputElementProps, { className: cx(dropdownSide === 'left' &&
                'left-0 pr-2 shadow-[8px_0_0_-7px_var(--alto)]', dropdownSide === 'right' &&
                'right-0 pl-2 shadow-[-8px_0_0_-7px_var(--alto)]'), style: { maxWidth: dropdownMaxWidth } }),
            React.createElement(Dropdown, __assign({}, dropdownProps, { isDisabled: disabled, options: options, value: selectedOptions, onChange: function (selectedValue) {
                    onChangeInputDropdown(inputValue, selectedValue);
                }, name: (_b = dropdownProps.name) !== null && _b !== void 0 ? _b : "input-dropdown-".concat(dropdownSide), styles: {
                    menu: function (provided) { return (__assign(__assign({}, provided), { width: "".concat(inputWidth, "px"), left: dropdownSide === 'left' ? 0 : '', right: dropdownSide === 'right' ? 0 : '' })); },
                    container: function (provided) { return (__assign(__assign({}, provided), { width: '100%' })); },
                    control: function (provided) { return (__assign(__assign({}, provided), { border: 'none', boxShadow: 'none', backgroundColor: 'none' })); },
                    dropdownIndicator: function (provided) { return (__assign(__assign({}, provided), { paddingLeft: '0px', paddingRight: dropdownSide === 'left' ? '0px' : '' })); },
                    option: function (provided, props) {
                        var isSelected = props.isSelected, data = props.data;
                        var lastPinned = data.lastPinned;
                        return __assign(__assign({}, provided), { backgroundColor: isSelected
                                ? 'var(--snuff)'
                                : 'unset', color: 'var(--mirage)', '&:hover': {
                                backgroundColor: 'var(--hover-grey)',
                            }, borderBottom: lastPinned
                                ? '2px solid var(--concrete)'
                                : 'unset' });
                    },
                } }))),
        dropdownSide === 'right' && input));
};
